<template>
  <div>
    <div class="workbench-overview">
      <el-card  class="overview-card">
        <div class="overview-content">
          <!-- 数据项 -->
          <div class="data-item">
            <div class="data-label">总客户量</div>
            <div class="data-icon">
              <i class="el-icon-user-solid"></i>
            </div>
            <div class="data-value">{{ this.totalRecords.newCustomers }}</div>
          </div>
          <div class="data-item">
            <div class="data-label">总销售额</div>
            <div class="data-icon">
              <i class="el-icon-money"></i>
            </div>
            <div class="data-value">¥{{ this.totalRecords.salesAmount }}</div>
          </div>
          <div class="data-item">
            <div class="data-label">总订单量</div>
            <div class="data-icon">
              <i class="el-icon-s-order"></i>
            </div>
            <div class="data-value">{{ this.totalRecords.totalOrders }}</div>
          </div>
        </div>
      </el-card>
    </div>
    <div class="middle">

      <div class="left">
        <date-selection :hasBorder="true"  @confirm-selection="fetchData" class="time"  />
        <h3 style="text-align: center;">{{info}}</h3>
        <div class="stats-row">
          <!-- 总订单量卡片 -->
          <el-card class="stat-card">
            <div class="stat-header">总订单量</div>
            <div class="stat-content">
              <span class="stat-value">{{ totalOrders }}</span>
            </div>
            <div
                class="stat-footer"
                :class="totalOrdersChange > 0 ? 'positive' : (totalOrdersChange < 0 ? 'negative' : 'neutral')"
            >
              <i v-if="totalOrdersChange > 0" class="el-icon-upload2 stat-icon"></i>
              <i v-else-if="totalOrdersChange < 0" class="el-icon-download stat-icon"></i>
              <i v-else class="el-icon-video-pause stat-icon"></i>

              <template v-if="totalOrdersChange !== 0">
                {{ totalOrdersChange > 0 ? '增加' : '减少' }}
                {{ Math.abs(totalOrdersChange) }}%
              </template>
              <span v-else class="stat-neutral">数据持平</span>

              <el-tooltip>
                <template #content>
                  <div>
                    <p>当前时间段订单量：{{ totalOrders }}</p>
                    <p>上个{{ selectedType }}订单量：{{ previousTotalOrders }}</p>
                    <p v-if="totalOrdersChange !== 0">
                      环比变化：{{ totalOrdersChange > 0 ? '增加' : '减少' }} {{ Math.abs(totalOrdersChange) }}%
                    </p>
                    <p v-else>环比变化：数据持平</p>
                  </div>
                </template>
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>
          </el-card>

          <!-- 销量金额卡片 -->
          <el-card class="stat-card">
            <div class="stat-header">销量金额</div>
            <div class="stat-content">
              <span class="stat-value">¥{{ formatAmount(salesAmount) }}</span>
            </div>
            <div
                class="stat-footer"
                :class="salesAmountChange > 0 ? 'positive' : (salesAmountChange < 0 ? 'negative' : 'neutral')"
            >
              <i v-if="salesAmountChange > 0" class="el-icon-upload2 stat-icon"></i>
              <i v-else-if="salesAmountChange < 0" class="el-icon-download stat-icon"></i>
              <i v-else class="el-icon-video-pause stat-icon"></i>

              <template v-if="salesAmountChange !== 0">
                {{ salesAmountChange > 0 ? '增加' : '减少' }}
                {{ Math.abs(salesAmountChange) }}%
              </template>
              <span v-else class="stat-neutral">数据持平</span>
              <el-tooltip>
                <template #content>
                  <div>
                    <p>当前时间段销量金额：¥{{ salesAmount }}</p>
                    <p>上个{{ selectedType }}销量金额：¥{{ previousSalesAmount }}</p>
                    <p v-if="salesAmountChange !== 0">
                      环比变化：{{ salesAmountChange > 0 ? '增加' : '减少' }} {{ Math.abs(salesAmountChange) }}%
                    </p>
                    <p v-else>环比变化：数据持平</p>
                  </div>
                </template>
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>
          </el-card>

          <!-- 新增客户卡片 -->
          <el-card class="stat-card">
            <div class="stat-header">新增客户</div>
            <div class="stat-content">
              <span class="stat-value">{{ newCustomers }}</span>
            </div>
            <div
                class="stat-footer"
                :class="newCustomersChange > 0 ? 'positive' : (newCustomersChange < 0 ? 'negative' : 'neutral')"
            >
              <i v-if="newCustomersChange > 0" class="el-icon-upload2 stat-icon"></i>
              <i v-else-if="newCustomersChange < 0" class="el-icon-download stat-icon"></i>
              <i v-else class="el-icon-video-pause stat-icon"></i>

              <template v-if="newCustomersChange !== 0">
                {{ newCustomersChange > 0 ? '增加' : '减少' }}
                {{ Math.abs(newCustomersChange) }}%
              </template>
              <span v-else class="stat-neutral">数据持平</span>
              <el-tooltip>
                <template #content>
                  <div>
                    <p>当前时间段新增客户：{{ newCustomers }}</p>
                    <p>上个{{ selectedType }}新增客户：{{ previousNewCustomers }}</p>
                    <p v-if="newCustomersChange !== 0">
                      环比变化：{{ newCustomersChange > 0 ? '增加' : '减少' }} {{ Math.abs(newCustomersChange) }}%
                    </p>
                    <p v-else>环比变化：数据持平</p>
                  </div>
                </template>
                <i class="el-icon-warning"></i>
              </el-tooltip>

            </div>
          </el-card>

        </div>
      </div>
      <div class="right">
        <!-- 公告通知标题 -->
        <div class="announcement-header">
          公告通知
          <div class="header-line"></div>
        </div>

        <!-- 公告列表 -->
        <div class="announcement-list">
          <div
              v-for="announcement in announcements"
              :key="announcement.id"
              class="announcement-item"
          >
            <!-- 公告标题 -->
            <el-popover
                placement="bottom"
                trigger="click"
                width="300"
            >
              <p>{{ announcement.noticeText }}</p>
              <span slot="reference" class="announcement-title">
          {{ announcement.title }}
        </span>
            </el-popover>

            <!-- 公告时间 -->
            <span class="announcement-time">
            {{ announcement.createTime }}
      </span>
          </div>
        </div>
      </div>

    </div>

    <div class="order">
      <div class="charts-row">
        <div class="chart-container">
          <mydateOrder />
        </div>
        <div class="chart-container">
          <mydateAmount />
        </div>
      </div>
      <div class="customer">
        <CustomerTrendChart />
      </div>
    </div>
<!--再加一个新增客户趋势图-->


  </div>
</template>
<script>
import dateSelection from "./utils/dateSelection.vue";
import salesChart from "./utils/SalesChart.vue";
import * as echarts from 'echarts';
import CustomerTrendChart from"./utils/mydateCustomer.vue"
import mydateOrder from"./utils/mydateOrderstate.vue"
import mydateAmount from "./utils/mydateAmount.vue";
export default {
  name:'myData',
  components:{
    dateSelection,
    salesChart,
    CustomerTrendChart,
    mydateOrder,
    mydateAmount
  },
  data() {
    return {
      // 公告数据
      announcements: [],
      logininfoId:"",
      totalOrders: 0,
      totalOrdersChange: 0,
      salesAmount: 0,
      salesAmountChange: 0,
      newCustomers: 0,
      newCustomersChange: 0,
      info: "",
      rankings: [],
      previousTotalOrders:0,
      previousSalesAmount:0,
      previousNewCustomers:0,
      selectedType:"",
      selectedValue:"",
      totalRecords:{},
    };
  },
  mounted() {
    const logininfo=JSON.parse(localStorage.getItem("logininfo"));
    this.logininfoId=logininfo.id;
    this.getTotalRecords();
this.getNotices();
    // 初始化默认时间：当前年份和月份
    this.currentYear = new Date().getFullYear(); // 获取当前年份
    this.currentMonth = String(new Date().getMonth() + 1).padStart(2, '0'); // 获取当前月份，格式化为两位数字

    // 默认数据类型和时间范围
    const defaultType = '月度';
    const defaultValue = `${this.currentYear}-${this.currentMonth}`; // 格式为 YYYY-MM

    // 调用数据加载方法
    this.fetchData({ type: defaultType, value: defaultValue });

    // 设置描述信息
    this.info = `${this.currentYear}年${this.currentMonth}月份我的数据`;


  },
methods:{
  getTotalRecords(){
    const params={
      logininfoId:this.logininfoId,
    }
    this.$http.get("/employeeRanking/totalrecords",{ params }).then(res=>{
      this.totalRecords = res.data;
    })
  },

  formatAmount(amount) {
    if (amount >= 10000) {
      return (Math.floor(amount / 10000 * 1000) / 1000).toLocaleString() + 'w'; // 转换为万，截取三位小数
    } else if (amount >= 1000) {
      return (Math.floor(amount / 1000 * 1000) / 1000).toLocaleString() + 'k'; // 转换为千，截取三位小数
    }
    return amount.toLocaleString(); // 小于1000，直接返回完整金额
  },
  fetchData({ type, value }) {
    // 接收子组件传递的数据
    this.selectedType = type;
    this.selectedValue = value;
    // 根据类型和时间更新 info
    this.updateInfo(type, value);
    //订单数量，金额，新增客户统计
    this.fetchEmployeeRankingData(type, value);
  },
  updateInfo(type, value) {
    if (type === "年度") {
      this.info = `${value}我的数据信息`;
    } else if (type === "季度") {
      const [year, quarter] = value.split("-Q"); // 分离年份和季度
      const quarterText = ["第一季度", "第二季度", "第三季度", "第四季度"][parseInt(quarter) - 1]; // 转换为中文描述
      this.info = `${year}年${quarterText}我的数据信息`;
    } else if (type === "月度") {
      const [year, month] = value.split("-");
      this.info = `${year}年${month}月我的数据信息`;
    }
  },
getNotices(){
  this.$http.get("/notice/allNotices").then(res => {
    this.announcements = res.data.map(item => {
      // 使用自定义的格式化方法对时间进行格式化
      return {
        ...item,
        createTime: this.$formatTimeYYYY(item.createTime) // 格式化时间
      };
    });
  });
},

  fetchEmployeeRankingData(type, value) {
    // 创建请求参数

    const params = {
      type: type,
      value: value,
      logininfoId:this.logininfoId
    };
    // 发送请求到后端，获取数据
    this.$http.get("/employeeRanking/mydataInfo", { params })
        .then(response => {
          const data = response.data;

          this.totalOrders = data.totalOrders;
          this.salesAmount = data.salesAmount;
          this.newCustomers = data.newCustomers;

          // 上一时间段数据
          this.previousTotalOrders = data.previousTotalOrders;
          this.previousSalesAmount = data.previousSalesAmount;
          this.previousNewCustomers = data.previousNewCustomers;

          // 计算增减百分比
          this.totalOrdersChange = this.previousTotalOrders === 0
              ? (this.totalOrders > 0 ? 100 : 0) // 如果上个时间段为 0，根据当前值判断增幅
              : (((this.totalOrders - this.previousTotalOrders) / this.previousTotalOrders) * 100).toFixed(2);

          this.salesAmountChange = this.previousSalesAmount === 0
              ? (this.salesAmount > 0 ? 100 : 0) // 如果上个时间段为 0，根据当前值判断增幅
              : (((this.salesAmount - this.previousSalesAmount) / this.previousSalesAmount) * 100).toFixed(2);

          this.newCustomersChange = this.previousNewCustomers === 0
              ? (this.newCustomers > 0 ? 100 : 0) // 如果上个时间段为 0，根据当前值判断增幅
              : (((this.newCustomers - this.previousNewCustomers) / this.previousNewCustomers) * 100).toFixed(2);
        }).catch(error => {
          console.error("获取数据失败:", error);
        });
  },
}

};
</script>

<style scoped>
.order{


}

.middle {
  display: flex; /* Flex 布局，使左右内容并排 */
  gap:16px ;
}

.left {
  flex: 2; /* 左侧宽度比例 */
  height: 280px; /* 左侧固定高度 */
}

.right {
  flex: 0.7; /* 宽度占比 */
  display: flex;
  flex-direction: column; /* 垂直排列 */
  height: 245px; /* 固定高度，保持与左侧一致 */
  border: 1px solid #ddd; /* 边框样式 */
  border-radius: 8px; /* 圆角 */
  padding: 10px; /* 内边距 */
  background-color: #fff; /* 背景色 */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* 阴影 */
}

.announcement-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #606266;
  text-align: center;
  position: relative; /* 用于控制线的位置 */
}

.header-line {
  position: absolute;
  bottom: -6px; /* 位于标题下方 */
  left: 0;
  right: 0;
  height: 1px;
  background-color: #ddd; /* 横线颜色 */
}


.announcement-list {
  flex: 1; /* 占满剩余空间 */
  overflow-y: auto; /* 启用垂直滚动条 */
  padding-right: 8px; /* 留出滚动条空间 */
}

.announcement-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.announcement-title {
  color: black;
  cursor: pointer;
}

.announcement-title:hover {
  text-decoration: underline;
}

.announcement-time {
  color: #909399;
  font-size: 14px;
}

.customerTrendChart{
  width: 50%;
}



.stats-row {
  display: flex;
  justify-content: space-between; /* 卡片紧挨排列 */
  align-items: stretch; /* 高度一致 */
  gap: 10px; /* 卡片之间的间距，尽量紧凑 */
  height: 150px;
  margin-right: 15px;
  margin-left: 10px;
  margin-bottom: 15px;
}

.stat-card {
  flex: 1; /* 每张卡片均匀分布 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 10px;
  padding: 15px; /* 内边距 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* 卡片阴影效果 */
}

.stat-header {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #606266; /* 标题颜色 */
}

.stat-content {
  font-size: 30px;
  font-weight: bold;
  color: #303133; /* 内容颜色 */
}

.stat-footer {
  font-size: 14px;
  margin-top: 10px;
  color: #606266; /* 默认字体颜色 */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 图标颜色控制 */
.stat-footer.positive .stat-icon {
  color: green; /* 增加时图标为绿色 */
}
.stat-footer.negative .stat-icon {
  color: red; /* 减少时图标为红色 */
}
.stat-footer.neutral .stat-icon {
  color: gray; /* 持平时图标为灰色 */
}

.stat-icon {
  margin-right: 5px; /* 图标与文字的间距 */
  font-size: 14px;
}

.workbench-overview {
  display: flex;
  padding: 20px;
}

.overview-card {
  width: 100%; /* 卡片宽度与容器一致 */
  max-width: 1200px; /* 限制最大宽度 */
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* 添加卡片阴影 */
}

.overview-content {
  display: flex;
  justify-content: space-around;
  gap: 20px;
  text-align: center;
}

.data-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.data-label {
  font-size: 14px;
  color: #888;
  margin-bottom: 8px;
}

.data-icon {
  font-size: 36px;
  color: #409eff;
  margin-bottom: 8px;
}

.data-value {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.order {
  margin: 15px; /* 整个容器的外边距 */
}

.charts-row {
  display: flex;
  gap: 20px; /* 左右间距 */
  margin-bottom: 20px; /* 上下间距 */
}

.chart-container {
  flex: 1; /* 平均分配空间 */
  min-width: 400px; /* 每个图表最小宽度 */
}
.customer{
  width: 50%;
}
.chart-container:last-child {
  margin-bottom: 0; /* 最后一行去除下边距 */
}
</style>



// WEBPACK FOOTER //
// myData.vue?7b0f225a